import * as React from 'react'
import MUIStack from '@mui/material/Stack'
import { StackProps } from '@mui/material'

export function Stack(props?: StackProps) {
  return <MUIStack {...props}>{props.children}</MUIStack>
}
